import { all, fork } from 'redux-saga/effects';
import create from './create';

export default function* events() {
  yield all([fork(create)]);
}
